import React, {useEffect, useState} from "react";
import axios from "axios";
import {API_URL} from "../../utils/Common";

export default function SelectFlores(props) {
    const {name, onChange } = props;
    const [flores, setFlores] = useState([]);

    useEffect(() => {
        axios.get(API_URL + '/flor/getTipoFlores')
            .then(r => {
                console.log(r);
                setFlores(r.data.tipoflores);
            });
    }, []);

    return (
        <div className="relative">
            <select className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name={name}
                    id={name}
                    onChange={onChange}>
                <option value="0">Ninguno</option> {/** <--- Valor inicial del select */}
                {
                    flores.map((f, i) => {
                        return (
                            <option key={i} value={f.id}>{ f.flor } { f.variedad } { f.color }</option>
                        )
                    })
                }
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
            </div>
        </div>
    )
}
